import React from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { useMemo } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useCallback } from "react";
import { useState } from "react";
import { useEffect } from "react";
import { IMAGE_GEEKO_LTD } from '../../../../../../../constants/index';
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useRef } from "react";
import { fetchUploadImage } from "../../../../../../../api";


const ReviewStarScore = props =>{
    const { starScore, changeComments, comment } = props;
    const Intl = useIntl();

    const getValue = useMemo(() =>{
        let str;
        if(starScore > 4){
            str = Intl.formatMessage({ id: "very_satisfied", defaultMessage: "Very Satisfied" });
        }else if(starScore > 3){
            str = Intl.formatMessage({ id: "satisfied", defaultMessage: "Satisfied" });
        }else if(starScore > 2){
            str = Intl.formatMessage({ id: "normal", defaultMessage: "Normal" });
        }else if(starScore > 1){
            str = Intl.formatMessage({ id: "bad", defaultMessage: "Bad" });
        }else if(starScore == 1){
            str = Intl.formatMessage({ id: "poor", defaultMessage: "Poor" });
        }
        return str;
    }, [starScore]);

    const starClick = useCallback((index) =>{
        changeComments({ score: index });
    }, [comment]);

    return <div className={cls.ReviewStarScore}>
        <span className={cls.Font1}><FormattedMessage id="rating" defaultMessage="Rating" /></span>

        <ol className={`${cls.PStars}`}>
            {
                [1,2,3,4,5].map((item,index) => {
                    if(starScore > index){
                        return starScore < index + 1 ? (<li className={cls.Half} key={item}></li>) : (<li className={cls.Active} key={item} onClick={() =>starClick(index+1)}></li>);
                    }else{
                        return (<li key={item} onClick={() =>starClick(index+1)}></li>)
                    }
                })
            }
        </ol>

        <span className={cls.Font2}>{getValue}</span>
    </div>
}

const OrderReviewTextarea = props =>{
    const { commentRules, orderReview, changeComments, comment } = props;
    const Intl = useIntl();

    const recordClick = useCallback(() =>{
        if(window.GeekoSensors){
            window.GeekoSensors.Track('ELClick', {
                clicks: 'Review Content Input',
                orderId: orderReview?.id
            })
        }
    }, [orderReview]);

    return <div className={cls.OrderReviewTextarea}>
        <textarea 
            placeholder={Intl.formatMessage({ id: "order_review_placeholder", defaultMessage: "Earn {point} points for comments over {wordNum} characters… *" }, { point: commentRules?.commentScore, wordNum: commentRules?.commentScore })}
            value={comment?.content} 
            maxLength="150" 
            onFocus={recordClick} 
            onChange={(evt) =>changeComments({ content: evt.target.value })} 
        >
        </textarea>
    </div>
}

const UploadImages = props =>{
    const { comment, commentRules, changeComments, setLoading } = props;
    const loadImageCount = useRef(6);

    const loadImage = useCallback(async (evt) =>{
        if(!(evt.target.files?.length > 0)){
            return;
        }
        setLoading(true);
        let formData = new FormData();
        formData.append("type","comment");
       
        let files = Array.from(evt.target.files);
        files?.forEach(file =>{
            formData.append("files", new File([file], file?.name));
        });
        
        let response = await fetchUploadImage(formData, { 'Content-Type': 'application/x-www-form-urlencoded' });
        if(response?.code === 200 && response?.result){
            const { result } = response;
            let urls = result?.map(item=>item?.url);
            let images = [...comment?.images, ...urls]?.slice(0, 6);
            changeComments({ images });
        }
        setLoading(false);
        
    }, [comment]);

    const removeImage = useCallback((index) =>{
        let images = [...comment?.images];
        images?.splice(index, 1);
        changeComments({ images: images });
    }, [comment]);

    return <div className={cls.UploadImages}>

        <div className={cls.Container}>
            {
               comment?.images?.map((image, index) =>(
                    <div key={image+index} className={cls.ImageItem}>
                        <img src={`${IMAGE_GEEKO_LTD}/comment/medium/${image}`} alt="IMAGE" />
                        <span className={cls.RemoveImg} onClick={() =>removeImage(index)}>&times;</span>
                    </div>
               ))
            }

            {
                comment?.images?.length < loadImageCount.current && <div className={cls.UploadImage}>
                    <form>
                        <input 
                            type="file" 
                            name="imageFiles" 
                            multiple="multiple" 
                            onChange={(e) =>loadImage(e)} 
                            accept="image/jpg,image/jpeg,image/png,image/gif"
                        />
                    </form>

                    <Iconfont className={cls.Icon}>&#xe68c;</Iconfont>

                    <span className={cls.Num}>{comment.images.length} / {loadImageCount.current}</span>
                </div>
            }
        </div>
        
        

        <p className={cls.Description}><FormattedMessage id="earn_more" defaultMessage="Earn more {points} points for comments with pictures" values={{ points: commentRules?.uploadImageScore }} /></p>
    </div>
}

const OverallFit = props =>{
    const { comment, changeComments } = props;

    return <div className={cls.OverallFit}>
        <div className={cls.Title}><FormattedMessage id="overall_fit" defaultMessage="Overall Fit" /></div>

        <div className={cls.FitSelect}>
            {
                comment?.fits?.map((fit, index)=>(
                    <div className={cls.FitItem} key={fit.value+index}>
                        <span 
                            className={`${fit?.value===comment?.sizingRecommendation ? cls.Active : ''}`} 
                            onClick={() =>changeComments({ sizingRecommendation: fit?.value })}
                        ></span>
                        <span>{fit?.label}</span>
                    </div>
                ))
            }
        </div>
    </div>
}

const OrderReview = props =>{
    const { comment, updateComments, commentRules, orderReview, setLoading } = props;

    const changeComments = useCallback((params) =>{
        let newComment = {...comment, ...params}
        updateComments(newComment);
    }, [comment]);

    return <div className={cls.OrderReview}>
        <div className={cls.OrderReviewCon}>
            <div className={cls.Product}>
                <div className={cls.Image}>
                    <a>
                        <img src={comment?.productImageUrl} alt={comment?.productName} />
                    </a>
                </div>

                <div className={cls.Message}>
                    <div className={cls.Container}>
                        <p className={cls.Name}>{comment?.productName}</p>
                        <p className={cls.SizeColor}>{comment?.color}/{comment?.size}</p>
                    </div>
                </div>
            </div>

            <div className={cls.StarList}>
                <ReviewStarScore starScore={comment?.score} changeComments={changeComments} comment={comment} />
            </div>

            <OrderReviewTextarea comment={comment} commentRules={commentRules} orderReview={orderReview} changeComments={changeComments} />
        
            <UploadImages comment={comment} commentRules={commentRules} changeComments={changeComments} setLoading={setLoading} />

            <OverallFit comment={comment} changeComments={changeComments} />
        </div>
    </div>
}

export default props =>{
    useStyles(cls);
    const { commentsList, updateComments, commentRules, orderReview, setLoading } = props;

    return <div className={cls.ReviewList}>
        {
            commentsList?.map((comment, index)=><OrderReview key={comment?.id+index} comment={comment} updateComments={updateComments} commentRules={commentRules} orderReview={orderReview} setLoading={setLoading} />)
        }
    </div>
}